/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit No/view.blocks to change it.
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function No({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/PatientOptions/Existing/Content/AppointmentSelect/Content/Content/AppointmentSelect/Content/Content/Appointments/Appointment/Booking/No"
  
}) {
  return null
}